import ManageAssigneeItem from './ManageAssigneeItem'

export default ManageAssigneeItem
